import * as React from 'react';
import { makeStyles, Typography, Card, CardHeader, CardContent, Box, CardActionArea } from '@material-ui/core';
import { displayLocalTime } from '../../util';

interface SRCardItemDetails {
	id: string;
	title: string;
	time: string;
	status: string | JSX.Element;
	reference: string;
	handleClick: any;
	isActive: boolean;
	description: string | undefined;
	location: string | undefined;
}

const useStyles = makeStyles(theme => ({
	area: {
		'&:hover $focusHighlight': {
			opacity: 0,
		},
	},
	card: {
		marginBottom: theme.spacing(2.25),
		borderRadius: '8px',
		boxShadow: '0px 3px 6px #00000029',
		width: '100%',
		minHeight: '124px',
		marginTop: '2px',
		'&:hover': {
			boxShadow: '0px 4px 6px #00000063',
		},
		cursor: 'pointer',
		font: 'normal normal normal 14px/17px Roboto',
		color: '#002855',
		'&:focus-visible': {
			outline: '2px solid black',
		},
	},
	header: {
		backgroundColor: '#CFDBE5',
		height: '32px',
		borderRadius: '8px 8px 0px 0px',
	},
	title: {
		margin: '-4px 0 2px 0',
		font: 'normal normal normal 16px/19px Roboto',
	},
	description: {
		color: '#565A5C',
		padding: '3px 0 1px 0',
	},
	location: {
		color: '#565A5C',
		margin: '2px 0 0 0',
	},
	time: {
		margin: '-4px 0 3px 0',
	},
	label: {
		color: '#002855',
	},
	reference: {
		margin: '4px 0 -3px 0',
	},
	focusHighlight: {},
}));

const SRCardListItem: React.FunctionComponent<SRCardItemDetails> = ({
	id,
	title,
	time,
	status,
	reference,
	handleClick,
	isActive = false,
	description = '',
	location = '',
}) => {
	const cardRef = React.useRef<{ [key: string]: HTMLButtonElement | null }>({});

	const setRef = (key: string, element: HTMLButtonElement | null) => {
		cardRef.current[key] = element;
	};

	const handelCardKeyDown = (id: string) => {
		handleClick();
		setTimeout(() => {
			cardRef.current[id]?.focus();
		}, 700);
	};
	const classes = useStyles();
	return (
		<Card
			tabIndex={0}
			id={id}
			ref={(el: HTMLButtonElement | null) => setRef(id, el)}
			variant="outlined"
			onKeyDown={e => {
				e.key === 'Enter' && handelCardKeyDown(id);
			}}
			className={classes.card}
		>
			<CardActionArea
				tabIndex={-1}
				classes={{
					root: classes.area,
					focusHighlight: classes.focusHighlight,
				}}
				onClick={handleClick}
				disableTouchRipple={true}
			>
				<CardHeader style={{ backgroundColor: isActive ? '#565A5C' : '' }} className={classes.header}></CardHeader>
				<CardContent>
					<Box display="flex">
						<Box display="flex" flexDirection="column" flexGrow={1} textAlign={'left'} maxWidth={'65%'}>
							<Typography variant="subtitle2" className={classes.title}>
								{title}
							</Typography>
							<Typography variant="caption" className={classes.description}>
								{description}
							</Typography>
							<Typography variant="caption" className={classes.location}>
								{location}
							</Typography>
						</Box>
						<Box display="flex" flexDirection="column" width={'35%'} textAlign={'right'}>
							<Typography variant="subtitle2" className={classes.time}>
								{displayLocalTime(time)}
							</Typography>
							<Typography variant="caption" color="textSecondary">
								<span className={classes.label}>Status:</span> {status}
							</Typography>
							<Typography variant="caption" color="textSecondary" className={classes.reference}>
								{reference && (
									<>
										<span className={classes.label}>Ref:</span> {reference}
									</>
								)}
							</Typography>
						</Box>
					</Box>
				</CardContent>
			</CardActionArea>
		</Card>
	);
};

export default SRCardListItem;
